import { api } from "@/lib/api";
import type { AdminDto } from "@/types/api";

export async function login(email: string, password: string): Promise<AdminDto> {
    const { data } = await api.post<AdminDto>("/admin/auth/login", { email, password });
    return data;
}

export async function logout(): Promise<void> {
    await api.post("/admin/auth/logout");
}

export async function me(): Promise<AdminDto | null> {
    try {
        const { data } = await api.get<AdminDto>("/admin/auth/me");
        return data;
    } catch {
        return null;
    }
}
